<template>
  <div class="uk-grid uk-grid-collapse uk-flex-middle tm-scheduletable-dropdown-list">
    <template v-if="worker['name'] !== '' && worker['email'] !==''">
      <!--photos_per_hour-->
      <div v-if="!worker['set_to_work'] || worker['set_to_work'] == 0"
           class="tm-scheduletable-dropdown-list-width-small">
        <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg tm-scheduletable-dropdown-list-cell-bg-black uk-text-bold" data-uk-tooltip="Ретушер отработал, но не записан на смену">
          {{ worker['productivity'] }}
        </div>
      </div>
      <div v-else-if=" worker['set_to_work'] == 3"  class="tm-scheduletable-dropdown-list-width-small">
        <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg-gray uk-text-bold">
          {{ worker['productivity'] }}
        </div>
      </div>
      <div v-else
           class="tm-scheduletable-dropdown-list-width-small">
        <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
          {{ worker['productivity'] }}
        </div>
      </div>

      <!--email-->
      <div class="uk-width-expand uk-text-left">
        <div class="tm-scheduletable-dropdown-list-cell" :id="worker['email']">
          <b>{{getNumberFromEmail(worker['email'], worker['role'])}}</b> {{ worker['name'] }}
        </div>
      </div>
      <!--role = junior-retoucher-->
      <div class="uk-text-left" v-if="worker['role'] === 'junior-retoucher'">
        <div class="tm-scheduletable-dropdown-list-cell">
          (test 0)
        </div>
      </div>
      <!--waiting_minutes + waiting_minutes + time-->
      <template v-if="isPast(day[0], item[0])">
        <div class="tm-scheduletable-dropdown-list-width-small">
          <div class="tm-scheduletable-dropdown-list-cell uk-text-bold" :class="worker['set_to_work'] == 3 ? ' tm-scheduletable-dropdown-list-cell-bg-gray ': ' tm-scheduletable-dropdown-list-cell-bg '">
            {{ worker['done_minutes'] }}
          </div>
        </div>
        <div class="tm-scheduletable-dropdown-list-width-small">
          <div class="tm-scheduletable-dropdown-list-cell uk-text-bold" :class="worker['set_to_work'] == 3 ? ' tm-scheduletable-dropdown-list-cell-bg-gray ': ' tm-scheduletable-dropdown-list-cell-bg '">
            {{ worker['waiting_minutes'] }}
          </div>
        </div>
        <div class="tm-scheduletable-dropdown-list-width-small">
          <div class="tm-scheduletable-dropdown-list-cell uk-text-bold" :class="worker['set_to_work'] == 3 ? ' tm-scheduletable-dropdown-list-cell-bg-gray ': ' tm-scheduletable-dropdown-list-cell-bg '">
            {{ worker['done_minutes'] + worker['waiting_minutes']}}
          </div>
        </div>
      </template>

      <!--autorenew-->
      <template v-else-if="!isPast(day[0], item[0]) && mustCancelReplace(worker)">
        <div>
          <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg"
               @click="showDialog(day[0], item[0], 'cancell of replacement by admin', worker['email'], worker['name'])"
               style="cursor: pointer;">
            <md-icon>autorenew</md-icon>
          </div>
        </div>
      </template>

      <!--clear-->
      <template v-else-if="!isPast(day[0], item[0]) && !mustCancelReplace(worker)">
        <div>
          <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg_"
               @click="showDialog(day[0], item[0], 'unsubscribe', worker['email'], worker['name'])"
               style="cursor: pointer;"
               data-uk-tooltip="title: Снять ретушера; offset: 5">
            <md-icon>clear</md-icon>
          </div>
        </div>
      </template>

      <!--lock-->
      <div v-if="!isPast(day[0], item[0])" class="itemTime_ pointer_">
        <label class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg_ uk-display-block" style="cursor: pointer;">
          <!--                -->
          <input type="checkbox"
                 style="position: absolute;display: none;"
                 :id="'keyLockToggleCheckRef-' + item[0]+day[0]+worker['email']"
                 :checked="keyLockIsChecked[item[0]][day[0]][worker['email']]['set_to_work'] == 2"
                 @change="keyLockToggleCheck($event, day[0],item[0], worker['email'])">
          <md-icon>{{
              keyLockIsChecked[item[0]][day[0]][worker['email']]['set_to_work'] == 2 ? 'lock' : 'lock_open'
            }}</md-icon>
        </label>
      </div>

    </template>
  </div>
</template>

<script>

export default {
  name: "ScheduleTable2RetoucherItem",
  props: {
    showDialog: {
      type: Function,
      require: true
    },
    local_page_keys: {
      type: Object,
      require: true
    },
    keyLockIsChecked: {
      type: Object,
      require: true
    },
    worker: {
      type: Object,
      require: true
    },
    day: {
      type: Array,
      require: true
    },
    item: {
      type: Array,
      require: true
    },
  },
  data() {
    return {
      //keyLockIsChecked:{},
      keyLockIstoSet: false
    }
  },
  methods: {
    getNumberFromEmail(email,role){
      if(email){

        if(email.match(/(\d+)(?=(.)*@)/) !== null){
          if( email.match(/(\d+)(?=(.)*@)/)[0]){
            return email.match(/(\d+)(?=(.)*@)/)[0];
          }
        }
        return role[0];
      }
      return email;
    },
    isPast(date, time) {
      let currdateTime = this.getFormatDateTime(date, time);
      let today = new Date();
      if (((Number(currdateTime.getTime()) - Number(today.getTime())) / (60 * 60 * 1000)) < 0) {
        return true;
      } else {
        return false;
      }
    },
    keyLockToggleCheck(event, day, item, email){

      let previousKeyLockIsToSet = item in this.keyLockIsChecked
          && day in this.keyLockIsChecked[item]
          && email in this.keyLockIsChecked[item][day]
          && this.keyLockIsChecked[item][day][email]
          && 'set_to_work' in this.keyLockIsChecked[item][day][email]
          ? this.keyLockIsChecked[item][day][email]['set_to_work']
          : 1 ;
      let keyLockIstoSet = event.target.checked ? 2 : 1;

      if(email){
        this.showDialog(day, item, 'update', email, null, {set_to_work: keyLockIstoSet}, {set_to_work: previousKeyLockIsToSet});
      }


    },
    set(obj, path, value) {
      var schema = obj;  // a moving reference to internal objects within obj
      var pList = path;
      var len = pList.length;
      for(var i = 0; i < len-1; i++) {
        var elem = pList[i];
        if( !schema[elem] ) schema[elem] = {}
        schema = schema[elem];
      }

      schema[pList[len-1]] = value;
    },

    mustCancelReplace(data) {

      if (!this.isAdmin() || this.isAdminView()) {
        if (typeof data == 'object' && Object.keys(data).length > 0 && 'replace' in data && data.replace) {
          return true;
        } else {
          return false;
        }
      } else {
        if (data.replace) {
          return true;
        } else {
          return false;
        }
      }

    },
    isAdmin() {
      if (this.role === 'admin') {
        return true;
      } else {
        return false;
      }
    },
    isAdminView() {
      if (this.isAdmin() && this.view === "admin") {
        return true;
      } else {
        return false;
      }
    },
    getHour(time) {
      return time.slice(-6);
    },
    getFormatDateTime(date, time) {
      let hour = 0;
      if (time) {
        hour = this.getHour(time);
        hour = Number(hour);
        if (hour === 0) {
          hour = 24;
        }
      }
      let year = Number(date.substring(0, 4));
      let month = Number(date.substring(5, 7));
      let day = Number(date.substring(8, 10));
      if (hour != 0) {
        return new Date(year, (month - 1), day, (hour - 1));
      } else {
        return new Date(year, (month - 1), day);
      }
    },
  },
  computed: {}
}
</script>

<style scoped></style>
